import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

@Component({ className: 'js-keyvisual-price-bar', observe: true })
export class KeyvisualPriceBarComponent {
	private stickyClass = 'is-sticky';
	private stickyTop = 0;
	private isTicking = false;

	constructor(public element: HTMLElement) {
		this.stickyTop = this.getStickyTop();
		this.updateStickyState();

		window.addEventListener('scroll', () => this.onScroll(), { passive: true });
		window.addEventListener('resize', () => this.onResize());
	}

	private onScroll() {
		if (this.isTicking) {
			return;
		}

		this.isTicking = true;
		window.requestAnimationFrame(() => {
			this.updateStickyState();
			this.isTicking = false;
		});
	}

	private onResize() {
		this.stickyTop = this.getStickyTop();
		this.updateStickyState();
	}

	private updateStickyState() {
		if (window.getComputedStyle(this.element).position !== 'sticky') {
			this.removeStickyClass();
			return;
		}
		
		const rect = this.element.getBoundingClientRect();
		const isPinned = rect.top - this.stickyTop <= 1;
		const hasReachedEnd = this.hasReachedContainerEnd(rect);
		const isSticky = isPinned && hasReachedEnd === false;

		if (isSticky) {
			addClass(this.element, this.stickyClass);
			return;
		}

		this.removeStickyClass();
	}

	private hasReachedContainerEnd(elementRect: DOMRect): boolean {
		if (this.element.parentElement === null) {
			return false;
		}

		const parentBottom = this.element.parentElement.getBoundingClientRect().bottom;

		return parentBottom <= this.stickyTop + elementRect.height;
	}

	private getStickyTop(): number {
		const rootStyle = window.getComputedStyle(document.documentElement);
		const isDesktop = window.matchMedia('(min-width: 1230px)').matches;
		const propertyName = isDesktop
			? '--navbar-header-height-desktop'
			: '--navbar-header-height';
		const topValue = rootStyle.getPropertyValue(propertyName);
		const top = parseFloat(topValue);

		if (Number.isNaN(top)) {
			return 0;
		}

		return top;
	}

	private removeStickyClass() {
		removeClass(this.element, this.stickyClass);
	}
}
